import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { ViewContainer } from "@components/view-container";
import { UserTableContextProvider } from "@hooks/use-table-context/user";
import { useUserTableDispatch } from "@hooks/use-table-context/user";
import { UsersTableComponent } from "./users-table-component";
import { AddUserModal } from "./add-user-modal";
import { fullBleedViewSx } from "@utils/colors";
import { useGetUsers } from "@hooks/use-get/users";

const UsersTableInner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState<any>(null);
  const { refreshItems } = useUserTableDispatch();
  const { wpUserId } = useParams<{ wpUserId?: string }>();
  const navigate = useNavigate();
  const { getSiteUserById } = useGetUsers();

  const handleOpenModal = (data?: any) => {
    setEditData(data?.id ? data : null);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setEditData(null);
    setIsModalOpen(false);
    if (wpUserId) navigate("/users", { replace: true });
  };

  useEffect(() => {
    if (!wpUserId) return;
    const id = Number(wpUserId);
    if (isNaN(id)) return;
    getSiteUserById(id).then((user) => {
      if (user) handleOpenModal(user);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wpUserId]);

  const handleSuccess = () => {
    handleCloseModal();
    refreshItems();
  };

  return (
    <ViewContainer className="users-table-view" sx={fullBleedViewSx}>
      <UsersTableComponent openUserModal={handleOpenModal} />
      <AddUserModal
        key={isModalOpen ? (editData?.id || "new") : "closed"}
        open={isModalOpen}
        onClose={handleCloseModal}
        onSuccess={handleSuccess}
        editData={editData}
      />
    </ViewContainer>
  );
};

export const UsersTable = () => {
  return (
    <UserTableContextProvider instanceId="page">
      <UsersTableInner />
    </UserTableContextProvider>
  );
};
